var map = {
	"./account.svg": "ecec",
	"./add.svg": "76a4",
	"./alert.svg": "659f",
	"./arrow-alt-left.svg": "cacd",
	"./arrow-alt-right.svg": "4a4e",
	"./arrow-down.svg": "c874",
	"./arrow-filled-down.svg": "a0dd",
	"./arrow-filled-up.svg": "9c8c",
	"./arrow-left.svg": "ac3b",
	"./arrow-right.svg": "cd8c",
	"./arrow-up.svg": "a3f8",
	"./bell-filled.svg": "0e16",
	"./bell.svg": "3d56",
	"./bulletin.svg": "bcf9",
	"./calendar.svg": "b8bd",
	"./clock.svg": "755b",
	"./close.svg": "8b1b",
	"./comment-filled.svg": "ad77",
	"./comment.svg": "c47d",
	"./contact.svg": "d015",
	"./copy.svg": "8aac",
	"./dashboard.svg": "ecef",
	"./dislike.svg": "a2a2",
	"./external-link.svg": "b64a",
	"./eye.svg": "7364",
	"./file.svg": "a147",
	"./inbox.svg": "2a9f",
	"./industry.svg": "0e44",
	"./like.svg": "6d8b",
	"./link.svg": "40a1",
	"./list.svg": "99ad",
	"./logo.svg": "5b1c",
	"./menu-day.svg": "05fe",
	"./menu-grid.svg": "ca26",
	"./menu.svg": "d17f",
	"./minus.svg": "3e24",
	"./monthgrid.svg": "56d0",
	"./monthview.svg": "253a",
	"./pending.svg": "e25a",
	"./power.svg": "111a",
	"./profile.svg": "95dc",
	"./project.svg": "2df1",
	"./project2.svg": "29bf",
	"./schedule.svg": "6b6fa",
	"./search.svg": "d103",
	"./setting.svg": "5de8",
	"./sort.svg": "f931",
	"./staff.svg": "d32e",
	"./stats.svg": "5c7e",
	"./trash.svg": "af22",
	"./user.svg": "6aed",
	"./vehicule.svg": "fd7f",
	"./view-day.svg": "6b62",
	"./view-month.svg": "fa72",
	"./weekgrid.svg": "4af2",
	"./weekview.svg": "05fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";